import TipoEstoqueService from "@/services/TipoEstoqueService";

export const tipoEstoque = {
  namespaced: true,
  state: {
    tipoEstoque: {},
  },
  actions: {
    getTipoEstoque({ commit }, payload) {
      return TipoEstoqueService.GetTipoEstoque(payload).then(
        (tipoEstoque) => {
          return Promise.resolve(tipoEstoque);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postTipoEstoque({ commit }, payload) {
      return TipoEstoqueService.PostTipoEstoque(payload).then(
        (tipoEstoque) => {
          return Promise.resolve(tipoEstoque);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putTipoEstoque({ commit }, payload) {
      return TipoEstoqueService.PutTipoEstoque(payload).then(
        (tipoEstoque) => {
          return Promise.resolve(tipoEstoque);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteTipoEstoque({ commit }, payload) {
      return TipoEstoqueService.DeleteTipoEstoque(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getTipoEstoqueOData({ commit }, payload) {
      return TipoEstoqueService.GetTipoEstoqueOData(payload).then(
        (tipoEstoque) => {
          return Promise.resolve(tipoEstoque);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default tipoEstoque;
